export enum ProjectRoutesNamesEnum {
  projectCreation = 'project-creation',
  address = 'address',
  applicant = 'applicant',
  certification = 'certification',
  certificationDetails = 'certification-details',
  certificationDocuments = 'certification-documents'
}
